import mapButtonProps from './mapButtonProps';

function extractPassThroughProps(componentsData) {
  const { scroller, ...passThroughProps } = componentsData;

  return passThroughProps;
}

function extractScroller(scroller) {
  if (!scroller?.length) return {};

  return {
    scroller: scroller.map(item => ({ src: item.url, alt: item.alt })),
  };
}

export default function headerBannerWithDynamicSliderMapper(componentsData) {
  return mapButtonProps({
    ...extractPassThroughProps(componentsData),
    ...extractScroller(componentsData.scroller),
  });
}
